import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://pyenbriacaivrnkwitqu.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5ZW5icmlhY2FpdnJua3dpdHF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNjExNjAsImV4cCI6MjA5MjgzNzE2MH0.VJsQRGFdiC4ahPDA9vsfgc13MKrEiPZHSdCdlysYaPk';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: {
    fetch: (url, options = {}) => {
      const separator = url.includes('?') ? '&' : '?';
      const urlWithKey = `${url}${separator}apikey=${SUPABASE_ANON_KEY}`;
      
      // Don't force JSON headers for storage requests
      const isStorageRequest = url.includes('/storage/');
      
      const headers = {
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        ...(isStorageRequest ? {} : {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }),
        ...options.headers,
      };
      return fetch(urlWithKey, { ...options, headers });
    }
  }
});